import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const getAllBillingsViaDataLineID = (dataLineID: number | undefined): Promise<IGetBillingReportViaDataLineID[]> => {
  return axiosDefaultApi.get(`/api/Billing/GetDataForDataLine/${dataLineID}`);
};

type QueryFnType = typeof getAllBillingsViaDataLineID;

type UseGetAllBillingsViaDataLineIDOptions = {
  dataLineID: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetAllBillingsViaDataLineID = ({ dataLineID , config }: UseGetAllBillingsViaDataLineIDOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [`getAllBillingsViaDataLineID_${dataLineID}`],
    queryFn: () => getAllBillingsViaDataLineID(dataLineID),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των χρεώσεων.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};